import { render, staticRenderFns } from "./SharedFooter.vue?vue&type=template&id=ab963f30&scoped=true&"
import script from "./SharedFooter.vue?vue&type=script&lang=js&"
export * from "./SharedFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab963f30",
  null
  
)

export default component.exports